import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatTooltip} from '@angular/material/tooltip';
import {ParticipantRole, ReferenceBookType} from '@npck/af-frontend-api';
import {KZT_CURRENCY_CODE} from '../../../../../../domain/constants';
import {ClassificationRow} from '../classification-table.component';

@Component({
    selector: 'af-classification-row-label',
    standalone: false,
    templateUrl: './classification-table-row-label.component.html',
    styleUrl: './classification-table-row-label.component.scss',
})
export class ClassificationTableRowLabelComponent implements OnInit {
    @ViewChild('tooltip') tooltip!: MatTooltip;
    @Input() participantRole: ParticipantRole;
    @Input() rowLabel!: ClassificationRow;
    @Input() hasCurrencyFilter: boolean = false;
    @Output() selectCurrency = new EventEmitter<string>();
    KZT_CURRENCY_CODE = KZT_CURRENCY_CODE;
    ReferenceBookType = ReferenceBookType;
    form: FormGroup<ClassificationRowForm>;

    constructor(private formBuilder: FormBuilder) {
    }

    ngOnInit(): void {
        if (this.hasCurrencyFilter) {
            this.form = this.formBuilder.group({currency: new FormControl(KZT_CURRENCY_CODE, [Validators.required])});
            this.form.controls.currency.valueChanges.subscribe(currency => this.selectCurrency.emit(currency));
        }
    }

}

interface ClassificationRowForm {
    currency: FormControl<string>;
}
